module.exports = __webpack_public_path__ + "img/audit-flow.3b07e558.svg";